'use strict';

require('../../style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/index.tsx
 ** module id = 303
 ** module chunks = 0
 **/